(() => {
	const initSlider = (section) => {
		let bannerSlider;

		if (document.currentScript) {
			bannerSlider = document.currentScript.parentElement.querySelectorAll(
				".js-slider-banner-slider"
			);
		} else {
			bannerSlider = section.querySelectorAll(".js-slider-banner-slider");
		}

		if (bannerSlider && bannerSlider.length > 0) {
			bannerSlider.forEach((el) => {
				const speed1 = Number(el.getAttribute("data-duration")) || 1000;
				const columnCount = Number(el.getAttribute("data-column-count")) || 7;
				const autoplayEnabled = el.getAttribute("data-autoplay") === "true";
				const autoplayDelayValue = Number(el.getAttribute("data-autoplay-delay"));
				const autoplayDelay = Number.isNaN(autoplayDelayValue)
					? 3000
					: autoplayDelayValue;
				const continuousRotation =
					el.getAttribute("data-continuous-rotation") === "true";
				const showNavigationArrows =
					el.getAttribute("data-show-navigation-arrows") === "true";
				const prevBtn = section.querySelector(".swiper-button-prev");
				const nextBtn = section.querySelector(".swiper-button-next");
				const slideCount = el.querySelectorAll(".swiper-slide").length;
				const enableLoop = continuousRotation && slideCount > 1;

				const logosSwiper1 = new Swiper(el, {
					slidesPerView: 2,
					spaceBetween: 16,
					autoplay: autoplayEnabled
						? {
								delay: autoplayDelay,
								disableOnInteraction: false,
								pauseOnMouseEnter: true,
								waitForTransition: true,
							}
						: false,
					direction: "horizontal",
					loop: enableLoop,
					loopAdditionalSlides: slideCount,
					speed: speed1,
					shortSwipes: true,
					longSwipes: false,
					allowTouchMove: true,
					navigation:
						showNavigationArrows && prevBtn && nextBtn
							? { nextEl: nextBtn, prevEl: prevBtn }
							: false,
					breakpoints: {
						576: {
							slidesPerView: Math.max(1, columnCount - 4 + 0.56),
							spaceBetween: 16,
						},
						990: {
							slidesPerView: Math.max(1, columnCount - 2 + 0.56),
							spaceBetween: 20,
						},
						1150: {
							slidesPerView: 6 + 0.56,
							spaceBetween: 20,
						},
						1250: {
							slidesPerView: columnCount + 0.56,
							spaceBetween: 20,
						},
					},
					mousewheel: {
						forceToAxis: true,
					},
				});

				if (autoplayEnabled && autoplayDelay === 0) {
					el.classList.add("banner-slider__content--continuous-motion");
				} else {
					el.classList.remove("banner-slider__content--continuous-motion");
				}
			});
		}
	};

	const initSection = (section) => {
		let sectionBanner;

		if (document.currentScript) {
			sectionBanner = document.currentScript.parentElement;
		} else {
			sectionBanner = section;
		}

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			const sliders = entry.target.querySelectorAll(".js-slider-banner-slider");
			const slidersSlow = entry.target.querySelectorAll(
				".js-slider-banner-slider-slow"
			);

			if (sliders.length != 0) {
				sliders.forEach((slider) => {
					if (slider.swiper) slider.swiper.destroy();
				});
			}

			if (slidersSlow.length != 0) {
				slidersSlow.forEach((slider) => {
					if (slider.swiper) slider.swiper.destroy();
				});
			}

			initSlider(sectionBanner);
		});

		initSlider(sectionBanner);

		sectionResizeObserver.observe(sectionBanner);
	};

	initSection();

	document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
	});
})();